import React, { useState } from 'react'
import { Select, TextField } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import Editable from '../../common/Editable'
import useKioskDropdownOptions from './hooks/useKioskDropdownOptions'
import { getBooleanDisplayValue } from '../../../util/StringUtil'
import DmcTemplePicker from '../../common/DmcTemplePicker'

export default function EditableKioskField({ fieldKey, value, isEditing, editableFieldsRef, languages }) {
  const { t } = useTranslation()
  const [fieldValue, setFieldValue] = useState(value)
  const { dropdownOptions } = useKioskDropdownOptions({ languages })

  const setKioskField = (changeValue) => {
    setFieldValue(changeValue)
    editableFieldsRef.current[fieldKey] = changeValue
  }

  const getDisplayValue = () => {
    switch (fieldKey) {
      case 'authorized':
        return getBooleanDisplayValue(fieldValue === 'true', t('Yes', 'Yes'), t('No', 'No'))
      case 'langCode':
        return `${fieldValue} - ${languages.find((lang) => lang.code === fieldValue)?.name}`
      case 'locationType':
        return t(`temple.kiosk.locationType.${fieldValue}`, fieldValue)
      default:
        return fieldValue
    }
  }

  const getEditableElement = () => {
    switch (fieldKey) {
      case 'locationType':
      case 'langCode':
      case 'authorized':
        return (
          <Select
            id={`edit-${fieldKey}`}
            hidePlaceholder
            value={fieldValue}
            options={dropdownOptions(fieldKey)}
            onChange={(e) => {
              setKioskField(e.target.value)
            }}
          />
        )
      case 'templeCode':
        return (
          <DmcTemplePicker
            label={null}
            templeCode={fieldValue}
            onSuggestionSelected={(selection) => setKioskField(selection?.templeCode)}
            onClear={() => setKioskField()}
          />
        )
      default: {
        return (
          <TextField
            id={`edit-${fieldKey}`}
            placeholder={fieldValue}
            value={fieldValue}
            onChange={(e) => {
              setKioskField(e.target.value)
            }}
          />
        )
      }
    }
  }

  return (
    <Editable text={getDisplayValue(fieldValue)} isEdit={isEditing}>
      {getEditableElement()}
    </Editable>
  )
}
